import React, { useCallback } from 'react';

function isSetterFn(value) {
  return typeof value === 'function';
}

function useInputState(initialValue) {
  const [value, setValue] = React.useState(initialValue);
  const setValueSafe = useCallback(newValueOrSetter => {
    setValue(oldValue => isSetterFn(newValueOrSetter) ? newValueOrSetter(oldValue) : newValueOrSetter);
  }, []);
  return [value, setValueSafe];
}

export { useInputState as default };
//# sourceMappingURL=useInputState.js.map
